module.exports = __webpack_public_path__ + "img/step_1.3b6cdf86.png";